const REF_FEATURE_STEP_NAME = {
  Register: 'register',
  Download: 'download',
  Share: 'share',
  Earn: 'earn',
  GiveAndGet: 'give-and-get'
}

const REF_FEATURE_STEP = {
  [REF_FEATURE_STEP_NAME.Register]: {
    text: 'Register',
    imageUrl: '/static/images/icons/custom/register.png'
  },
  [REF_FEATURE_STEP_NAME.Download]: {
    text: 'Download',
    imageUrl: '/static/images/icons/custom/download.png'
  },
  [REF_FEATURE_STEP_NAME.Share]: {
    text: 'Share',
    imageUrl: '/static/images/icons/custom/share.png'
  },
  [REF_FEATURE_STEP_NAME.Earn]: {
    text: 'Earn',
    imageUrl: '/static/images/icons/custom/earn.png'
  },
  [REF_FEATURE_STEP_NAME.GiveAndGet]: {
    text: 'Give & Get',
    imageUrl: '/static/images/icons/custom/earn.png'
  }
}

import {ReferralProgramType} from './enums/referral.enum.js'

const REF_FEATURE_MAP = {
  [ReferralProgramType.NonMonetary]: [
    REF_FEATURE_STEP_NAME.Register,
    REF_FEATURE_STEP_NAME.Download,
    REF_FEATURE_STEP_NAME.Share
  ],
  [ReferralProgramType.ReferralAward]: [
    REF_FEATURE_STEP_NAME.Download,
    REF_FEATURE_STEP_NAME.Share,
    REF_FEATURE_STEP_NAME.Earn
  ],
  [ReferralProgramType.GiveAndGet]: [
    REF_FEATURE_STEP_NAME.Download,
    REF_FEATURE_STEP_NAME.Share,
    REF_FEATURE_STEP_NAME.GiveAndGet
  ],
  [ReferralProgramType.GiveAndGetAndLoyalty]: [
    REF_FEATURE_STEP_NAME.Download,
    REF_FEATURE_STEP_NAME.Share,
    REF_FEATURE_STEP_NAME.GiveAndGet
  ]
}

export function featuresByProgram (programType) {
  var steps = REF_FEATURE_MAP[programType]
  return steps ? steps.map((name) => REF_FEATURE_STEP[name]) : []
}



// WEBPACK FOOTER //
// ./scripts/src/shared/referral.js